import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { EMAIL_SCHEMA_FIELD_NAME } from "./EmailFormField.schema";

/**
 * EmailFormField provides support for a standard Input component to be used as
 * a email field in a Form.
 */

export const EmailFormField = (props) => {
  const {
    caption,
    className,
    componentProps,
    disabled,
    label = i18n("EmailFormField__LABEL"),
    name = EMAIL_SCHEMA_FIELD_NAME,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      caption,
      className,
      componentProps: {
        "aria-label": i18n("EmailFormField__ARIA"),
        ...componentProps,
        type: "email",
      },
      disabled,
      label,
      name,
    };
  }
};

export const emailFormFieldPropTypes = {
  /** Value used to display under the email input */
  caption: PropTypes.string,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Label to identify the form field. */
  label: PropTypes.node,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

EmailFormField.propTypes = emailFormFieldPropTypes;
